import { createSelector } from '@ngrx/store';
import { CombinationOP } from '@cemex-core/cmx-api';
import { getRmsSpecificationPage } from './index';

export const getOpenPlatformCombinationsState = createSelector(
  getRmsSpecificationPage,
  state => state.combinationsOpenPlatformState,
);

export const getOpenPlatformCombinations = createSelector(getOpenPlatformCombinationsState, state => {
  const combinations: CombinationOP[] = [];
  for (const key in state.entities) {
    if (Object.prototype.hasOwnProperty.call(state.entities, key)) {
      combinations.push(state.entities[key]);
    }
  }
  return combinations;
});
